import { render, staticRenderFns } from "./PopoverActorCard.vue?vue&type=template&id=4a276786&scoped=true&"
import script from "./PopoverActorCard.vue?vue&type=script&lang=ts&"
export * from "./PopoverActorCard.vue?vue&type=script&lang=ts&"
import style0 from "./PopoverActorCard.vue?vue&type=style&index=0&id=4a276786&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a276786",
  null
  
)

export default component.exports